import { Badge } from "@chakra-ui/react";
import { Edit, Trash2, Sliders } from "lucide-react";
import {
  TableColumn,
  TableAction,
  ActionHandler,
} from "@/components/section/EntityTableSection";
import { Organization, getOrganizationStatusColor } from "./api";
import { OrganizationAction } from "./hooks/useOrganizationActions";
import RelativeTime from "@/components/ui/RelativeTime";
import TableText from "@/components/ui/TableText";

export const createOrganizationColumns = (): TableColumn<Organization>[] => [
  {
    key: "id",
    title: "ID",
    variant: "id",
  },
  {
    key: "name",
    title: "NAME",
    variant: "primary",
  },
  {
    key: "status",
    title: "STATUS",
    render: (organization) => (
      <Badge
        size="sm"
        colorPalette={getOrganizationStatusColor(organization.status)}
        variant="subtle"
      >
        {organization.status}
      </Badge>
    ),
  },
  {
    key: "payment_provider",
    title: "PAYMENT",
    render: (organization) => (
      <TableText>
        {organization.payment_provider?.display_name ||
          organization.payment_provider?.name ||
          "N/A"}
      </TableText>
    ),
  },
  {
    key: "trial_ends_at",
    title: "TRIAL ENDS",
    render: (organization) => (
      <TableText>
        {organization.trial_ends_at
          ? new Date(organization.trial_ends_at).toLocaleDateString("en-US", {
              year: "numeric",
              month: "short",
              day: "numeric",
              timeZone: "UTC"
            })
          : "N/A"}
      </TableText>
    ),
  },
  {
    key: "subscription_ends_at",
    title: "SUBS. ENDS",
    render: (organization) => (
      <TableText>
        {organization.subscription_ends_at
          ? new Date(organization.subscription_ends_at).toLocaleDateString("en-US", {
              year: "numeric",
              month: "short",
              day: "numeric",
              timeZone: "UTC"
            })
          : "N/A"}
      </TableText>
    ),
  },
  {
    key: "created",
    title: "CREATED",
    render: (organization) => <RelativeTime date={organization.created_at} />,
  },
  {
    key: "updated",
    title: "UPDATED",
    render: (organization) => (
      <RelativeTime
        date={organization.updated_at}
        fallbackDate={organization.created_at}
      />
    ),
  },
];

export const createOrganizationActions = (
  onAction: ActionHandler<Organization, OrganizationAction>,
  isLoading: boolean
): TableAction<Organization>[] => [
  {
    key: "edit",
    label: "Edit",
    icon: Edit,
    onClick: (entity) => onAction("edit", entity),
    disabled: isLoading,
  },
  {
    key: "delete",
    label: "Delete",
    icon: Trash2,
    onClick: (entity) => onAction("delete", entity),
    disabled: isLoading,
    colorPalette: "red",
  },
  {
    key: "edit_configuration",
    label: "Change Settings",
    icon: Sliders,
    onClick: (entity) => onAction("edit_configuration", entity),
    disabled: isLoading,
    colorPalette: "cyan",
  },
];
